import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'kbUpload',
  version: '1.0.0',
  properties: [
    // ==================================================================
    // COLLECTION CONFIGURATION
    // ==================================================================
    {
      key: 'collectionId',
      label: 'Collection',
      type: 'options',
      required: true,
      default: '',
      options: [],
      optionsSource: 'knowledgeBaseCollections',
      description: 'The knowledge base collection to upload to',
      placeholder: 'Select a collection...',
    },

    // ==================================================================
    // INPUT CONFIGURATION
    // ==================================================================
    {
      key: 'inputType',
      label: 'Input Type',
      type: 'options',
      required: false,
      default: 'auto',
      options: [
        { value: 'auto', name: 'Auto-detect' },
        { value: 'field', name: 'Text Field' },
        { value: 'binary', name: 'Binary (Base64)' },
      ],
      description: 'How to interpret the input data',
    },
    {
      key: 'sourceField',
      label: 'Source Field',
      type: 'string',
      required: false,
      default: 'content',
      placeholder: 'e.g., content, data.text, or data for binary',
      description: 'Field path containing the content (for text) or base64 data (for binary)',
      displayOptions: {
        show: {
          inputType: ['auto', 'field'],
        },
      },
    },
    {
      key: 'documentName',
      label: 'Document Name',
      type: 'string',
      required: false,
      default: '',
      placeholder: 'e.g., {{ $json.title }} or "My Document"',
      description: 'Name for the document. Auto-generated if empty.',
    },

    // ==================================================================
    // CHUNKING CONFIGURATION
    // ==================================================================
    {
      key: 'chunkSize',
      label: 'Chunk Size',
      type: 'number',
      required: false,
      default: 1000,
      typeOptions: {
        minValue: 100,
        maxValue: 8000,
      },
      description: 'Maximum characters per chunk',
    },
    {
      key: 'chunkOverlap',
      label: 'Chunk Overlap',
      type: 'number',
      required: false,
      default: 200,
      typeOptions: {
        minValue: 0,
        maxValue: 2000,
      },
      description: 'Character overlap between chunks for context continuity',
    },

    // ==================================================================
    // METADATA
    // ==================================================================
    {
      key: 'metadata',
      label: 'Metadata (JSON)',
      type: 'json',
      required: false,
      default: '',
      placeholder: '{"source": "workflow", "tags": ["important"]}',
      description: 'Optional JSON metadata to attach to the document',
    },
  ],
};

export default schema;
